module.exports = __webpack_public_path__ + "img/icon-presidents-01.5eaa12cc.png";